<template>
  <el-row class="core_one_wrap">
    <el-col class="one_left">
      <div class="left_tit">
        {{ core.subTitle }}
      </div>
      <ul class="left_desc">
        <li>
          {{ core.desc }}
        </li>
      </ul>
      <div class="left_card">
        <div class="card_item" v-for="(item, index) in core.children" :key="index">
          <span class="item_txt">{{ item }}</span>
        </div>
      </div>
    </el-col>
    <el-col class="one_right">
      <img :src="core.image" alt="">
    </el-col>
  </el-row>
</template>

<script>
import ScrollReveal from 'scrollreveal'
export default {
  data() {
    return {
    }
  },
  props: {
    core: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      ['.left_tit', '.left_desc', '.card_item', '.one_right'].forEach(v => {
        ScrollReveal().reveal(v, {
          distance: '10px',
          duration: 800,
          interval: 100,
          origin: 'bottom',
          reset: false,
          viewFactor: 0.6
        })
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.core_one_wrap {
  display: flex;
  justify-content: center;
  text-align: left;
  margin-bottom: 30px;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }

  .one_left {
    width: 40%;

    @media screen and (max-width: 768px) {
      width: 90%;
    }

    .left_tit {
      font-size: 23px;
      font-weight: bold;
      color: #3e3e3e;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }

    .left_desc {
      color: #717171;
      padding: 10px 40px 20px 40px;

      li {
        line-height: 25PX;
      }

      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }

    .left_card {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 25px;
      margin-right: 80px;

      @media screen and (max-width: 768px) {
        margin: 0;
      }

      .card_item {
        box-sizing: border-box;
        width: 30%;
        height: 50px;
        background: #fff;
        box-shadow: 0 -0.0625rem 0.4375rem 0 silver,
          0 0 0.75rem 0 rgb(0 0 0 / 10%);
        display: flex;
        align-items: center;
        color: #0991d3;
        padding: 0 20px;
        cursor: pointer;

        @media screen and (max-width: 768px) {
          height: 50PX;
        }

        i {
          font-size: 1.3rem;
        }

        &:nth-child(n + 4) {
          margin-top: 30px;

          @media screen and (max-width: 768px) {
            margin-top: 16PX;
          }
        }

        &:hover .item_txt {
          letter-spacing: 4px;
        }

        .item_txt {
          width: 100%;
          font-weight: bold;
          font-size: 17px;
          margin-left: 10px;
          transition: all 1s;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }
      }
    }
  }

  .one_right {
    width: 20%;
    height: 100%;

    @media screen and (max-width: 768px) {
      width: 70%;
      margin-top: 20PX;
    }

    img {
      width: 100%;
      margin-top: 40px;
    }
  }
}
</style>